import { render, staticRenderFns } from "./bindingLogin.vue?vue&type=template&id=336f4cea&scoped=true&"
import script from "./bindingLogin.vue?vue&type=script&lang=js&"
export * from "./bindingLogin.vue?vue&type=script&lang=js&"
import style0 from "./bindingLogin.vue?vue&type=style&index=0&id=336f4cea&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336f4cea",
  null
  
)

export default component.exports